<section class="park-top" *ngIf="featured.length">
  <div class="park-top-steps">
    <usb-park-steps [steps]="steps" [current]="1" [maxReached]="1"></usb-park-steps>
  </div>

  <div class="park-featured">
    <button type="button" class="park-featured-arrow" [style.visibility]="canPrev ? 'visible' : 'hidden'"
            (click)="move(-1)" aria-label="Anterior"><i class="fas fa-chevron-left"></i></button>

    <div class="park-featured-track" #track (scroll)="updateArrows()">
      <article class="park-featured-card" *ngFor="let f of featured; trackBy: trackByHotel"
               role="button" tabindex="0" (click)="select.emit(f.hotel)" (keydown.enter)="select.emit(f.hotel)">
        <img class="park-featured-img" [src]="f.image" [alt]="f.name" loading="lazy" />
        <div class="park-featured-shade"></div>
        <h5 class="park-featured-name">{{ f.name }}</h5>
        <div class="park-featured-price">
          <small>Desde</small>
          <strong>
            {{ currencyAgency?.code }}
            {{ f.price | currencyConverterPure: f.currency: currencyAgency?.code: currencies | number: '1.0-0' }}
          </strong>
        </div>
        <span *ngIf="f.tier" class="park-featured-tier">{{ f.tier }}</span>
      </article>
    </div>

    <button type="button" class="park-featured-arrow" [style.visibility]="canNext ? 'visible' : 'hidden'"
            (click)="move(1)" aria-label="Siguiente"><i class="fas fa-chevron-right"></i></button>
  </div>
</section>
